import { GT_ORIGIN } from './dayShare'

export const SLUG_MIN = 3
export const SLUG_MAX = 40
export const JOIN_MESSAGE_MAX = 200

const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

const RESERVED = new Set([
  'about',
  'admin',
  'api',
  'app',
  'blog',
  'coach',
  'explore',
  'g',
  'goaltree',
  'grove',
  'groves',
  'gt',
  'help',
  'join',
  'login',
  'new',
  'null',
  'official',
  'request',
  'settings',
  'signin',
  'signup',
  'staff',
  'support',
  'team',
  'today',
  'undefined',
  'www',
])

export const isValidSlug = (s: string) =>
  s.length >= SLUG_MIN &&
  s.length <= SLUG_MAX &&
  SLUG_RE.test(s) &&
  !s.includes('--') &&
  !RESERVED.has(s)

export const normalizeSlug = (raw: string) => raw.trim().toLowerCase()

// Best-effort default from the grove name; may still be taken or too short.
export function suggestSlug(name: string) {
  const s = name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SLUG_MAX)
    .replace(/-+$/, '')
  return s.length >= SLUG_MIN && !RESERVED.has(s) ? s : ''
}

export const groveShowcaseUrl = (slug: string) => `${GT_ORIGIN}/g/${slug}`
